<template>
  <v-app>
    <v-app-bar
      app
      :color="groupSetting.mainColor"
      dark
      v-if="appBarFlag"
    >
      <div class="d-flex align-center">
        <v-img
          alt="Logo"
          class="shrink mr-2"
          contain
          :src="groupSetting.logoUrl"
          transition="scale-transition"
          :width="groupSetting.logoSize"
        />
        <span class="shrink">{{ groupSetting.groupName }} 작업 관리 시스템</span>
      </div>

      <v-spacer></v-spacer>

      <span v-if="isLoggedIn"></span>

<!--      <router-link v-if="!isLoggedIn" to="/user/login">-->
<!--      <v-btn v-on:click="userLogin" icon>-->
<!--        <v-icon>mdi-login</v-icon>-->
<!--      </v-btn>-->
<!--      </router-link>-->

      <div class="d-none d-sm-flex">
        <AddClientButton v-if="isLoggedIn" v-bind:button-text="'거래처'" :button-color="groupSetting.mainColor"></AddClientButton>
        <AddFactoryButton v-if="isLoggedIn" v-bind:button-text="'공장'" :button-color="groupSetting.mainColor"></AddFactoryButton>
      </div>

      <v-btn v-if="isLoggedIn" v-on:click="userLogout" icon>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-app-bar
            app
            :color="groupSetting.mainColor"
            dark
            v-if="!appBarFlag"
    >
      <div class="d-flex align-center">
        <v-img
                alt="Logo"
                class="shrink mr-2"
                contain
                :src="groupSetting.logoUrl"
                transition="scale-transition"
                :width="groupSetting.logoSize"
        />
        <span class="shrink">{{ this.groupSetting.groupName }} 주문 확인</span>
      </div>

      <v-spacer></v-spacer>

      {{ clientName }}

      <v-btn v-if="!appBarFlag" v-on:click="customerLogout" icon>
        <v-icon>mdi-logout</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-slide-y-transition mode="out-in">
        <router-view/>
      </v-slide-y-transition>
    </v-main>

    <v-footer fixed v-if="appBarFlag">
      <v-container class="mx-auto caption">
<!--        Copyright &copy; 2020 bspojang All Rights Reserved.-->
        <v-btn
                v-for="icon in bottomIcons"
                :key="icon.id"
                class="mx-4"
                icon
                :color="groupSetting.mainColor"
        >
          <router-link v-if="icon.role == null || (userRole == 'superuser' && groupSetting.groupName == '방산포장')" :to="icon.routerPath">
            <v-icon :color="groupSetting.mainColor" size="24px">{{ icon.icon }}</v-icon>
          </router-link>
        </v-btn>
      </v-container>
    </v-footer>

    <v-footer fixed v-if="!appBarFlag">
      <v-container class="mx-auto caption">
        Copyright &copy; 2020 {{ groupSetting.groupName }} All Rights Reserved.
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
import AddClientButton from "@/components/admin/button/AddClientButton";
import AddFactoryButton from "./components/admin/button/AddFactoryButton";

export default {
  name: 'OrderManagementSystem',

  components: {
    AddFactoryButton,
    AddClientButton
  },

  data: () => ({
    appBarFlag: false,
    bottomIcons: [
      {
        id: 1,
        icon: 'mdi-cash',
        routerPath: '/dashboard/estimation',
        role: 'superuser'
      },
      {
        id: 2,
        icon: 'mdi-clipboard-list-outline',
        routerPath: '/dashboard',
        role: null
      },
      {
        id: 3,
        icon: 'mdi-calendar',
        routerPath: '/dashboard/calendar',
        role: null
      },
      {
        id: 4,
        icon: 'mdi-view-list-outline',
        routerPath: '/dashboard/clients',
        role: null
      },
      {
        id: 5,
        icon: 'mdi-cog',
        routerPath: '/dashboard/settings',
        role: null
      }
    ],
    clientName: null,
    groupSetting : null,
    userRole: null
  }),
  methods: {
    userLogout() {
      this.$store.dispatch('userLogout')
    },
    customerLogout() {
      this.$store.dispatch('customerLogout', this.$route.params.clientCode)
    },
    checkHash() {
      if(location.hash.match(/client\//g)){
        this.appBarFlag = false
      }else{
        this.appBarFlag = true
      }
    },
    updateClientName() {
      const clientInfo = this.$store.getters.clientInfo
      if(clientInfo && clientInfo.clientName){
        this.clientName = clientInfo.clientName + "님 반갑습니다."
      }
    },
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.getAccessToken != null
    }
  },
  created: function() {
    if(this.$store.getters.getGroupSetting != null){
      this.groupSetting = this.$store.getters.getGroupSetting
      this.userRole = this.$store.getters.getUserRole
    }
  },
  mounted: function(){
    this.checkHash()
    this.updateClientName()
  },
  updated() {
    this.checkHash()
    this.updateClientName()
  }
};
</script>

<style>
@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 100;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Thin.otf) format('opentype');}
@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 300;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Light.otf) format('opentype');}
@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 400;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Regular.otf) format('opentype');}
@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 500;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Medium.otf) format('opentype');}
@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 700;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Bold.otf) format('opentype');}
@font-face {font-family: 'Noto Sans KR';font-style: normal;font-weight: 900;src: url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff2) format('woff2'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.woff) format('woff'),url(//fonts.gstatic.com/ea/notosanskr/v2/NotoSansKR-Black.otf) format('opentype');}

body, .v_toolbar__title {
  font-family: 'Noto Sans KR', sans-serif;
}
</style>
